export default "__VITE_ASSET__bae6824f__"